import { createRequestActions } from "common/helpers/action";

export const initCpCompanyAdd = createRequestActions("CP.COMPANY.ADD.INIT");
export const sendCpCompanyAdd = createRequestActions("CP.COMPANY.ADD.SEND");

export const searchCompanyCpCompanyAdd = createRequestActions("CP.COMPANY.ADD.SEARCH_COMPANY");
export const searchPCompanyCpCompanyAdd = createRequestActions("CP.COMPANY.ADD.SEARCH_PARENT_COMPANY");
